import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import React from "react"
import {PUBLIC_KEY } from "../../../config/serverInfo";
import PaymentForm from "./PaymentForm"



const stripeTestPromise = loadStripe(PUBLIC_KEY)

export interface StripeContainerProps {
    clientSecret: string,
    done: Function
}
const StripeContainer: React.FC<StripeContainerProps> = ({ done, clientSecret }) => {
    return (
        <>
            < Elements stripe={stripeTestPromise} >
                <PaymentForm done={done} clientSecret={clientSecret} />
            </Elements >
        </>
    )
}
export default StripeContainer